import { UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Card, Col, Input, Rate, Row, Space } from 'antd'
import moment from 'moment'
import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { AuthContext } from '../../../contexts/Auth'
import { postReplyReview } from '../../../services/Host'

interface IReviewData {
  name: string
  comment: string
  licenseNumber: string
  vehicleModel: string
  reserveStartTime: string
  reserveStopTime: string
  reservationNo: number
  reply: any[]
}

interface IReviewCardProps {
  reviewData: IReviewData
}

const { TextArea } = Input

const StyledButton = styled(Button)`
  border-radius: 18rem;
  background-color: #0046a0;
`

const ReviewCard: React.FC<IReviewCardProps> = ({ reviewData }) => {
  const {
    name,
    comment,
    licenseNumber,
    vehicleModel,
    reserveStartTime,
    reserveStopTime,
    reservationNo,
    reply,
  } = reviewData

  const isShowReplyBox = reply.length === 0
  const [showOpenReply, setShowOpenReply] = useState(isShowReplyBox)
  const [showReply, setShowReply] = useState(false)
  const [replyText, setReplyText] = useState('')
  const [replyData, setReplyData] = useState(reply)
  const authContext = useContext(AuthContext)

  const startTime = reserveStartTime ? moment(reserveStartTime).format('HH:mm, DD MMM YYYY') : ''
  const stopTime = reserveStopTime ? moment(reserveStopTime).format('HH:mm, DD MMM YYYY') : ''

  const openReplyBox = () => {
    setShowReply(true)
    setShowOpenReply(false)
  }
  const replyReview = async () => {
    const data = { reservationNo, text: replyText }
    await postReplyReview(authContext, data)
    setReplyData([{ text: replyText }])
    setShowReply(false)
    return true
  }

  const ReplyDisplay: React.FC<{ reply: any[] }> = ({ reply }) => {
    if (reply.length > 0) {
      return (
        <Row justify="space-between">
          <Col span={24}>
            <p>Your Reply:</p>
            <p style={{ paddingLeft: '20px' }}>{reply[0].text}</p>
          </Col>
        </Row>
      )
    } else {
      return <></>
    }
  }
  return (
    <>
      <Card style={{ marginBottom: '10px' }}>
        <Row>
          <Space align="start">
            <Col>
              {/* <Image
                width={60}
                height={60}
                src="error"
                fallback="data:image/png;base64,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"
              /> */}
              <Avatar size={50} icon={<UserOutlined />} />
            </Col>
            <Col>
              <p>{name}</p>
            </Col>
          </Space>
        </Row>
        <Row>
          <Col>
            <Rate disabled allowHalf defaultValue={4.3} style={{ color: '#0046A0' }} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <p style={{ paddingLeft: '20px' }}>{comment}</p>
          </Col>
        </Row>
        <br />
        <Row>
          <Col span={16}>
            <p>
              {licenseNumber}, {vehicleModel}
            </p>
            <p>
              {startTime} - {stopTime}
            </p>
          </Col>
          <Col span={8} style={{ textAlign: 'right' }}>
            {showOpenReply && (
              <Button
                type="default"
                loading={false}
                onClick={() => openReplyBox()}
                disabled={false}
                style={{ borderRadius: '18px', borderColor: '#0046A0', color: '#0046A0' }}
              >
                Reply
              </Button>
            )}
          </Col>
        </Row>
        {showReply && replyData.length === 0 && (
          <Row justify="space-between" style={{ textAlign: 'right' }}>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <TextArea rows={4} onChange={(e) => setReplyText(e.target.value)} />
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <StyledButton
                    type="primary"
                    loading={false}
                    onClick={() => replyReview()}
                    disabled={false}
                  >
                    Reply
                  </StyledButton>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
        <ReplyDisplay reply={replyData} />
      </Card>
    </>
  )
}

export default ReviewCard
